import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';
import Login from './Login';
import Axios from 'axios'
import { URL } from '../api';

import Swal from 'sweetalert2'

// CommonJS


export default class Home extends Component {
    
    //    state = {
    //       Username: "",
    //       Password: "",
    //       loading: true,
    //       login_error: true,
    //       login_error2: true,
    //       login_error3: true,
    //     }

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
            };
            this.handleChange = this.handleChange.bind(this);
            this.handleChange2 = this.handleChange2.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);
            this.toggle = this.toggle.bind(this);
          }


          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }
        
          handleChange(event) {    this.setState({value: event.target.value});  }
          handleChange2(event) {    this.setState({Psaaword: event.target.value});  }



      
          handleSubmit(event) {
            // alert('A name was submitted: ' + this.state.value);
             event.preventDefault();

            const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
         datafrm.append("txtemail", this.state.value);
         datafrm.append("txtpass", this.state.Psaaword);

         
         const user = {
          "txtemail": this.state.value,
          "txtpass": this.state.Psaaword
        };

         fetch('https://mua.kpru.ac.th/FrontEnd_Mis/login/login/', {
          method: 'POST',
          body: JSON.stringify(user),
          headers: {
          
          }
        })
          .then(res => res.json())
          .then((res) => {
              console.log(res);
            //  console.log(res);
              if (res[0].loginstatus === "1" && res[0].employee_id === "000956" || res[0].employee_id === "000961" 
              || res[0].employee_id === "000425" || res[0].employee_id === "000090" || res[0].employee_id === "001506" 
              || res[0].employee_id === "000149" || res[0].employee_id === "001422" || res[0].employee_id === "001322" 
              || res[0].employee_id === "001329" || res[0].employee_id === "000859" 
              || res[0].employee_id === "000198" || res[0].employee_id === "000017" || res[0].employee_id === "001523" 
              || res[0].employee_id === "001468" || res[0].employee_id === "001561" 
              || res[0].employee_id === "001465" || res[0].employee_id === "000355" || res[0].employee_id === "001546"
              || res[0].employee_id === "001612" || res[0].employee_id === "001589" || res[0].employee_id === "001648" 
              || res[0].employee_id === "001643" || res[0].employee_id === "000756" || res[0].employee_id === "000914"
              || res[0].employee_id === "001675" || res[0].employee_id === "001679" || res[0].employee_id === "001683"
              || res[0].employee_id === "001727" || res[0].employee_id === "000151" || res[0].employee_id === "001663" 
              || res[0].employee_id === "001267" 
            ) {

           //000355 ผดุงพร พันธ์พืช  งานทะเบียน
           //000956 กฤษณะ กฤษณะ  คณะวิทยาศาสตร์
           //000425 คัทลียา ปัญญาอูด  คณะเทคโนโลยีอุตสาหกรรม
           //000090 ขนิษฐา ศิริรัตน์  คณะมนุษยศาสตร์และสังคมศาสตร์
           //000149 วาสนา จันทร์ผ่อง คณะครุศาสตร์
           //001267 น.ส.พิมพ์ประภัส เหมือนพลอย  ศูนย์ภาษา
           //001322 ศิริทร ศิริคุณ  มหาวิทยาลัยราชภัฏกำแพงเพชร แม่สอด
           //001329 ปวีณา รักชาติพานิช คณะเทคโนโลยีอุตสาหกรรม
           //000859 จักกริช มีสี  บัณฑิตวิทยาลัย
           //000198 อิสราวัชร เฟื่องอิ่ม คณะมนุษยศาสตร์และสังคมศาสตร์
           //000017 สุภาภรณ์ นุชรุ่งเรือง คณะวิทยาการจัดการ
           //001523 รุ่งทิวา ฉัตรชัยสุริยา คณะมนุษยศาสตร์และสังคมศาสตร์
           //001648 นันท์นลิน มั่งเมือง ศูนย์ภาษา
           //001468 ธนวัตน์ วัดเกลี้ยพงษ์ คณะครุศาสตร์
           //001561 ณัฏฐากร บุญค้ำ คณะวิทยาการจัดการ
           //001561 ภูทริยา มีอุสาห์ คณะวิทยาการจัดการ
           //001465 วันธนะพล หมั่นหา คณะพยาบาลศาสตร์
           //001612 วิลาวัลย์ ชุมแวงวาปี ศูนย์ภาษา
           //000756 สุกัญญา ธรรมธีระศิษฏ์ แม่สอด
           //000756 เฉลิมรัตน์  จันทร์กระจ่าง คณะมนุษยศาสตร์และสังคมศาสตร์
           //001675 น.ส.วรรณพร ปงรังสี แม่สอด
           //001679 อารียา พิทยาธำรง คณะวิทยาการจัดการ
           //001727 ชนากานต์ ก่ำการยุทธ คณะวิทยาการจัดการ

                //  alert("เข้าสู่ระบบสำเร็จ")

                   localStorage.setItem('name', res[0].frist_name +"  "+ res[0].last_name);
      
                   message.success("เข้าสู่ระบบสำเร็จ")
                   localStorage.setItem('loginstatus', res[0].loginstatus);
                   localStorage.setItem('type2', res[0].employee_id);
                  // localStorage.setItem('pic', res[1].UrlPic);
                 
              //  window.location.href = '/components/administrator/reportall'
              // window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/adminfaculty'

                //ตรวจสอบว่าเป็นงานทะเบียน
                if (res[0].loginstatus === "1" && res[0].employee_id === "000355" || res[0].employee_id === "001546" || res[0].employee_id === "001506" || res[0].employee_id === "001663") {
                  window.location.href = 'https://e-student.kpru.ac.th/grade/adminfacultyfortabian'
                 // window.location.href = '/grade/adminfacultyfortabian'
                } else {
                  window.location.href = 'https://e-student.kpru.ac.th/grade/adminfaculty'
                 // window.location.href = '/grade/adminfaculty'
                }
                   //  window.location.href = 'https://e-student.kpru.ac.th/grade/adminfaculty'

              }else{
                 // message.error("เข้าสู่ระบบไม่สำเร็จ")
                 Swal.fire(
                  'ไม่สามารถเข้าถึงระบบได้',
                  'กรุณาลองอีกครั้ง',
                  'question'
                )
                //  window.location.href = '/'
              }
            
          })
          .catch(err => {
            console.log('request failed', err);
          })
         

          }

    update = () => {
        this.setState({
            name: "",
            lname: ""
        })
    }

    render() {
      console.log(this.state.value)
      console.log(this.state.Psaaword)
      const Swal = require('sweetalert2')
        return (
            <div>
                <MDBContainer fluid>
                    <MDBRow >

                      
                    <MDBCol md="2">
                    </MDBCol>
                        <MDBCol md="10">
                            <div>
                        <br/>

                        <img src="https://e-student.kpru.ac.th/creditbank/static/media/logokpru.78cc9560.png" className="rounded mx-auto d-block w-50" alt="aligment" /><br/>
                            
                        <form onSubmit={this.handleSubmit}>
                            <p className="h5 text-center ">เข้าสู่ระบบตรวจสอบการส่งเกรด</p>
                            <p className="h5 text-center "> สำหรับเจ้าหน้าที่คณะ</p>
                            <div className="grey-text">
                            <MDBInput label="Username" icon="user" group type="text" validate error="wrong"
                                success="right"  name="Username" value={this.state.value} onChange={this.handleChange}/>

                            <MDBInput label="Password" icon="key" group type="password" validate error="wrong"
                                success="right" value={this.state.Psaaword} onChange={this.handleChange2} />

                            </div>
                            <div className="text-center">
                            <MDBBtn outline color="info" type="submit" value="Submit" >
                             เข้าสู่ระบบ
                                <MDBIcon far icon="paper-plane" className="ml-1" />
                            </MDBBtn>
                            </div>
                        </form>
                          {/* <Login/> */}
                           {/* {this.state.value}
                           {this.state.Psaaword} */}
                           <div>
                             <br/>
                             <a href="https://e-student.kpru.ac.th/grade/download/adminfaculty.pdf" target="_blink" ><MDBBtn outline color="secondary">คู่มือการใช้งานระบบสำหรับเจ้าหน้าที่คณะ</MDBBtn></a>
                           </div>
                          
                        </div>
                        </MDBCol>
                        <MDBCol md="">
                          
                    </MDBCol>
                    </MDBRow>

                    <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
        <MDBModalHeader toggle={this.toggle}>
        </MDBModalHeader>
        <MDBModalBody className="text-center">
         
        <MDBIcon icon="exclamation-circle" className="red-text text-center" size="5x" />
         <h3>usermame หรือ password ไม่ถูกต้อง</h3>
         <h3>กรุณาตรวจสอบความถูกต้อง อีกครั้ง!</h3>
        </MDBModalBody>
       
      </MDBModal>
                   
                    </MDBContainer>
                   
            </div>
        )
    }
}
